import { render, staticRenderFns } from "./LocationTargetingComponent.vue?vue&type=template&id=1370b092&scoped=true&"
import script from "./LocationTargetingComponent.vue?vue&type=script&lang=js&"
export * from "./LocationTargetingComponent.vue?vue&type=script&lang=js&"
import style0 from "./LocationTargetingComponent.vue?vue&type=style&index=0&id=1370b092&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1370b092",
  null
  
)

export default component.exports